<template>
  <div id="multiselectdiscounts" class="mt2">
    <div class="dropdown dropdown-filter" @click="showDropdown">
      <div class="overselect"></div>
      <div class="c-form-input">
        <h3 class="raleway-semi-p13">Offres exclusives</h3>
        <img src="../../images/Fleche haut.svg" v-set-alt v-if="show" />
        <img src="../../images/flechebas-simple.svg" v-set-alt v-else />
      </div>
    </div>
    <div class="multiselect" v-if="show">
      <ul>
        <div class="row-selectoptions mt-3" :class="{ row: !isPhone }">
          <div :class="{ 'col-10': !isPhone }">
            <li>
              <input type="checkbox" id="long-weekend" :value="false" v-model="selectedWeekend" />
              <label class="raleway-reg-p13" :class="{ 'ml-2': !isPhone }" for="long-weekend">
                Offre long week-end <span class="filter-count">({{ getDiscountCount('long-weekend') || 0 }})</span>
              </label>
            </li>
            <li>
              <input type="checkbox" id="long-sejour" :value="false" v-model="selectedSejour" />
              <label class="raleway-reg-p13" :class="{ 'ml-2': !isPhone }" for="long-sejour">
                Offre long séjour <span class="filter-count">({{ getDiscountCount('long-sejour') || 0 }})</span>
              </label>
            </li>
          </div>
        </div>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MultiselectDiscounts',
  props: ['options', 'filterCounts'],
  data() {
    return {
      show: false,
      selectedWeekend: false,
      selectedSejour: false,
    };
  },
  methods: {
    showDropdown() {
      this.show = !this.show;
    },
    getDiscountCount(discountType) {
      if (!this.filterCounts || !this.filterCounts.discount_types) return 0;
      const discountData = this.filterCounts.discount_types.find(d => d.key === discountType);
      return discountData ? discountData.count : 0;
    },
  },
  watch: {
    selectedWeekend(val) {
      const discounts = [];
      if (val) discounts.push('long-weekend');
      if (this.selectedSejour) discounts.push('long-sejour');
      this.$emit('checked', discounts, 'discounts');
    },
    selectedSejour(val) {
      const discounts = [];
      if (this.selectedWeekend) discounts.push('long-weekend');
      if (val) discounts.push('long-sejour');
      this.$emit('checked', discounts, 'discounts');
    },
  },
  computed: {
    isPhone() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
        return true;
      } else {
        return false;
      }
    },
  }
};
</script>

<style lang="scss" scope="app/assets/stylesheets/components/lodging-filter">
.filter-count {
  color: #666;
  font-size: 0.9em;
  font-weight: normal;
  margin-left: 4px;
}
</style>